var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRing4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 272,
    viewBox: "0 0 270 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.05
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135 247C196.026 247 245 197.027 245 136C245 74.9729 196.026 25 135 25C73.9738 25 25 74.9729 25 136C25 197.027 73.9738 247 135 247Z",
    stroke: "#516CD3",
    strokeWidth: 50
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing4);
export default __webpack_public_path__ + "static/media/Ring4.5a7987b1530af7f68412bb40e905f48b.svg";
export { ForwardRef as ReactComponent };